<template>
  <div class="logo-container-case-card" :style="logoContainerStyle">
    <div class="inner-spinner">
      <div v-for="(color, i) in spinTheme" :key="i" :style="spinCircleStyle(i)"></div>
    </div>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
      viewBox="0 0 640 573" enable-background="new 0 0 640 573" xml:space="preserve">
      <g>
        <path :fill="logoTheme" d="M625.8,114.7H241.5v33.7l-2,59.6h3.9c29.7-66.6,82.6-85.5,120.6-85.5h16.1v369.1c0,53.1-31,69.9-49.6,72.5
          v0.1h205v-0.1c-20.6-2.6-48.3-19.4-48.3-72.5V122.4h16.1c38,0,90.9,18.7,120.6,85.5h3.9l-2-59.6v-33.6L625.8,114.7L625.8,114.7z"/>
        <path :fill="logoTheme" d="M307.8,335.1c0-64.7-34.8-110.1-120-142.4c-58-22-92.9-47.9-92.9-99.7c0-49.2,40-79,85.1-79
          c57.4,0,88.3,42,107.1,93.8h3.9l-1.3-45.3V17.8C262,13.9,226.6,7.4,181.4,7.4C81.5,7.4,21.8,51.6,12.1,119.2v41.9
          C21,225,69.6,252.6,122.7,274.8c62.5,25.9,96.1,53.1,96.1,106.9c0,57-34.8,84.9-89,84.9c-63.8,0-98.6-55.7-115.4-95.2h-2.3v90.2
          c29,6.4,71.7,12.1,119.6,12.1C221.5,473.6,307.8,431.6,307.8,335.1z"/>
      </g>
    </svg>
  </div>
</template>

<script>
export default {
  data () {
    return {
      theme: 'lightcolor', // lightblue, darkblue, lightcolor, darkcolor
      spinScheme: {
        blue: ['#0C2B57', '#7C91A6', '#00214F', '#747D86'],
        color: ['#0C2B57', '#C72A77', '#FED402', '#23A299']
      }
    }
  },
  computed: {
    spinTheme () {
      return this.isColorTheme ? this.spinScheme.color : this.spinScheme.mono
    },
    logoTheme () {
      return this.isDarkTheme ? '#FFFFFF' : '#333333'
    },
    stLoadingStyle () {
      return {
        backgroundColor: this.isDarkTheme ? '#000000' : '#FFFFFF'
      }
    },
    logoContainerStyle () {
      return {
        border: this.isDarkTheme ? '1px solid #656565' : '1px solid #D8D8D8'
      }
    },
    isDarkTheme () {
      return this.theme.indexOf('dark') !== -1
    },
    isColorTheme () {
      return this.theme.indexOf('color') !== -1
    }
  },
  methods: {
    spinCircleStyle (i) {
      return {
        backgroundColor: this.spinTheme[i],
        animationDuration: (1 + 0.3 * i) + 's'
      }
    }
  }
}
</script>

<style lang="scss">
$logoWidthTribute: 60px;
$spinCircleWidth: 12px;
$spinBound: ($logoWidthTribute - $spinCircleWidth) / 2;

.logo-container-case-card {
  position: relative;
  width: $logoWidthTribute;
  height: $logoWidthTribute;
  border-radius: 100%;

  .inner-spinner {
    // border-radius: 100%;
    // border: 0.05em solid #d8d8d8;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: $logoWidthTribute - $spinCircleWidth;
    height: $logoWidthTribute - $spinCircleWidth;

    & > div {
      width: $spinCircleWidth;
      height: $spinCircleWidth;
      opacity: 0.85;
      position: absolute;
      border-radius: 100%;
      transform-origin: $spinBound $spinBound;
      animation: rota linear infinite;
    }
  }

  svg {
    position: absolute;
    width: 28px;
    height: 28px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

@keyframes rota {
  to {
    transform: rotate(360deg);
  }
}
</style>
